import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function UserAccountInformativeBannerSection(): ReactElement {
  const { t } = useTranslation('userAccount', { keyPrefix: 'UserAccountInformativeBannerSection' })

  return (
    <div className='grid grid-rows-1'>
      <div>{t('Description')}</div>
    </div>
  )
}
